import { jwtDecode } from "jwt-decode";
import { refreshUser } from '@/api/user.js';

import store from '@/store/index.js';


export async function checkLogin() {
    if (store.getters.USER_EMAIL === null) {
        if (localStorage.access_token != null && localStorage.refresh_token != null) {
            let decodeValue = jwtDecode(localStorage.access_token);
            store.commit('SET_USER', decodeValue);
            return true;
        }
        return false;
    }
    return true;
}

export async function saveToken(data) {
    if (!data || typeof data.access_token !== 'string' || typeof data.refresh_token !== 'string') {
        console.error('[FIX] saveToken: received invalid token data — expected {access_token, refresh_token} strings', {
            dataType: typeof data,
            hasAccessToken: data && typeof data.access_token,
        });
        throw new Error('saveToken: access_token and refresh_token must be strings');
    }

    const decodeValue = jwtDecode(data.access_token);

    localStorage.access_token = data.access_token;
    localStorage.refresh_token = data.refresh_token;

    store.commit('SET_USER', decodeValue);
}

export async function getToken() {
    if (await checkLogin() === false) return null;
    await checkToken();
    return `Bearer ${localStorage.access_token}`;
}

export async function checkToken() {
    const currentData = Math.floor(Date.now() / 1000);
    const tokenData = store.getters.USER_TOKEN_TIME;

    if (currentData < tokenData.expiration && currentData >= tokenData.create) {
        return;
    }

    await refreshUser();
}

export async function deleteToken() {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
}